import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Flex,
  useToast,
} from '@chakra-ui/react'
import { DragAndDrop } from '../../../../components/DragAndDrop'
import { FormProvider, useForm } from 'react-hook-form'
import { useMutation, useQueryClient } from 'react-query'
import { api } from '../../../../services/api'

async function updateLayout(data) {
  //enviar um formdata
  const response = await api.post('/arte-produto/produto-layout', data)

  return response.data
}

export function ModalAlterarLayout({ codProd, sequencia, nome, numeroNota }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const queryClient = useQueryClient()

  const methods = useForm()
  const toast = useToast({
    position: 'top-right',
    duration: 5000,
    isClosable: true,
  })

  const { resetField } = methods

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: updateLayout,
    onSuccess: () => {
      onClose()

      toast({
        title: 'Layout alterado com sucesso',
        status: 'success',
      })

      queryClient.invalidateQueries('layouts')

      resetField('files')
    },

    onError: (error) => {
      toast({
        title: 'Erro ao alterar layout',
        description: error.response.data.erros,
        status: 'error',
      })
    },
  })

  const onSubmit = (data) => {
    const formData = new FormData()

    formData.append('cod_prod', codProd)
    formData.append('sequencia', sequencia)
    formData.append('numero_nota', numeroNota)
    formData.append('arquivo', data.files)

    console.log(Object.fromEntries(formData))

    mutateAsync(formData)
  }

  return (
    <>
      <Button onClick={onOpen} colorScheme="blue">
        Alterar Layout
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="2xl">
        <ModalOverlay />
        <ModalContent as="form" onSubmit={methods.handleSubmit(onSubmit)}>
          <FormProvider {...methods}>
            <ModalHeader>Alterar Layout</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              Você está alterando o layout do produto {nome} com o código {codProd}.
              <Flex mt={4} flexDir="column" gap={4}>
                <DragAndDrop control={methods.control} />
              </Flex>
            </ModalBody>

            <ModalFooter>
              <Button variant="ghost" mr={3} onClick={onClose}>
                Fechar
              </Button>
              <Button colorScheme="blue" type="submit" isLoading={isLoading}>
                Alterar
              </Button>
            </ModalFooter>
          </FormProvider>
        </ModalContent>
      </Modal>
    </>
  )
}
